import pessoas from '../../assets/pillars/pillar-pessoas.png';
import inovacao from '../../assets/pillars/pillar-inovacao.png';
import excelencia from '../../assets/pillars/pillar-excelencia.png';
import eco from '../../assets/pillars/pillar-eco.png';
import integridade from '../../assets/pillars/pillar-integridade.png';

const PILLARS = [
  ['Pessoas', pessoas],
  ['Inovação', inovacao],
  ['Excelência', excelencia],
  ['Eco', eco],
  ['Integridade', integridade],
];

/** The five GroundLink pillars, original artwork, on a glass bar. */
export function PillarsBar() {
  return (
    <div
      className="mx-auto mb-4 flex h-[56px] md:h-[72px] max-w-3xl items-center justify-center gap-3 md:gap-6 overflow-hidden rounded-2xl border border-white/15 px-3 md:px-6 py-2 backdrop-blur-md"
      style={{ background: 'rgba(7,16,29,0.62)' }}
      role="group"
      aria-label="GroundLink pillars"
    >
      {PILLARS.map(([name, src]) => (
        <img key={name} src={src} alt={name} className="h-full w-auto" draggable={false} />
      ))}
    </div>
  );
}
